import { render, staticRenderFns } from "./ApprovalColorPicker.vue?vue&type=template&id=2d4a68c5&scoped=true"
import script from "./ApprovalColorPicker.vue?vue&type=script&lang=js"
export * from "./ApprovalColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ApprovalColorPicker.vue?vue&type=style&index=0&id=2d4a68c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a68c5",
  null
  
)

export default component.exports